<div class="labelcontainer width100procent">
    <div class="labeltitle">{{title$ | async}}</div>
    <div class="labeltext">{{value$ | async}}</div>
</div>
